import { useQuery } from '@tanstack/react-query';
import { SystemMessageTemplate } from '@/types/system-message-templates';
import { getAccessToken } from '@/lib/supabase';

async function fetchSystemMessageTemplates(): Promise<SystemMessageTemplate[]> {
  const token = await getAccessToken();

  if (!token) {
    throw new Error('Not authenticated');
  }

  const response = await fetch('/api/system-message-templates', {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch system message templates');
  }
  return response.json();
}

export function useSystemMessageTemplates() {
  return useQuery({
    queryKey: ['system-message-templates'],
    queryFn: fetchSystemMessageTemplates,
  });
}
